import { LanguageCode } from './types';
import type { LanguageCodeType } from './index';
import { getLocaleResourceCode } from './locale';

export const isInLangList = (lang: LanguageCodeType) => {
  return Object.values(LanguageCode).map((l) => l.toLowerCase()).includes((lang || '').toLowerCase());
};

// 精确匹配
const getLanguageCodeFromExactMatch = (lang: string): LanguageCodeType | undefined => {
  return Object.values(LanguageCode).map((l) => ({ key: l, value: l.toLowerCase() })).find((l) => (lang || '').toLowerCase() === l.value)?.key as LanguageCodeType;
};

// 模糊匹配
const getLanguageCodeFromFuzzyMatch = (lang: string): LanguageCodeType | undefined => {
  return Object.values(LanguageCode).map((l) => { return { key: l, value: l.toLowerCase() }; }).find((l) => lang.startsWith(l.value))?.key as LanguageCodeType;
};

/**
 * 保留已有语言的业务码格式，并将没有实际语言包的枚举值收敛为英文。
 */
const normalizeSupportedLanguageCode = (languageCode?: LanguageCodeType): LanguageCodeType => {
  if (!languageCode) return LanguageCode.en;
  if (languageCode === LanguageCode.zh) return LanguageCode.zhHans;
  if (languageCode === LanguageCode.zhHans) return LanguageCode.zhHans;
  if (languageCode === LanguageCode.zhHant) return LanguageCode.en;

  return getLocaleResourceCode(languageCode);
};

/**
 * 将 URL、缓存或浏览器语言映射到当前真正支持的业务语言。
 */
export const mapLanguageCode = (lang: string): LanguageCodeType => {
  const lowerLang = (lang || '').toLowerCase();
  if (isInLangList(lowerLang as LanguageCodeType)) {
    return normalizeSupportedLanguageCode(getLanguageCodeFromExactMatch(lowerLang));
  }
  const code = getLanguageCodeFromFuzzyMatch(lowerLang);

  return normalizeSupportedLanguageCode(code);
};
